import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import {
    StyledInfoFooter,
} from './styles/Footer.styled'
import moment from 'moment'

interface Item {
    title: string
    links: NavLink[]
}

interface NavLink {
    name: string
    url: string
    cnOnly?: boolean
}

const Footer = () => {
    const { t } = useTranslation()


    return (
        <StyledInfoFooter>
                                ©{moment().format('YYYY')} Shop Business Power - Helping Texas businesses reduce energy costs with smarter choices. <br />
                                Shop Business Power is not affiliated with any government agency or utility company.<br />
        </StyledInfoFooter>
    )
}

export default Footer
